import type { IconDef } from '../types';

export const mic: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M20 8C20.55 8 21 8.45 21 9V11C21 15.6 17.5198 19.4097 13.0498 19.9297L12.96 22H16C16.55 22 17 22.45 17 23C17 23.55 16.55 24 16 24H7.99023C7.44023 24 6.99023 23.55 6.99023 23C6.99023 22.45 7.44023 22 7.99023 22H10.9502L11.04 19.9502C6.53004 19.4702 3 15.64 3 11V9C3 8.45 3.45 8 4 8C4.55 8 5 8.45 5 9V11C5 14.86 8.14 18 12 18C15.86 18 19 14.86 19 11V9C19 8.45 19.45 8 20 8ZM12 0C14.76 0 17 2.24 17 5V11C17 13.76 14.76 16 12 16C9.24 16 7 13.76 7 11V5C7 2.24 9.24 0 12 0ZM12.2598 2C10.6099 1.93013 9.19988 3.2202 9.12988 4.87012L8.87012 10.8604C8.80031 12.5102 10.0903 13.9202 11.7402 13.9902C13.3901 14.0601 14.8001 12.77 14.8701 11.1201L15.1299 5.12988C15.1998 3.47993 13.9097 2.07 12.2598 2Z',
    },
  ],
};
